'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _alertLocal = require('./alert.local.css');

var _alertLocal2 = _interopRequireDefault(_alertLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Component for displaying messages with status context
 */


var Alert = function Alert(_ref) {
  var className = _ref.className,
      kind = _ref.kind,
      message = _ref.message,
      secondaryMessage = _ref.secondaryMessage,
      isVisible = _ref.isVisible,
      onClose = _ref.onClose;

  if (!isVisible) {
    return null;
  }

  return _react2.default.createElement('div', {
    className: (0, _classnames2.default)([_alertLocal2.default.alert, _alertLocal2.default['alert--' + kind], className])
  }, onClose && _react2.default.createElement('button', {
    onClick: onClose,
    'data-auto': 'closeButton',
    className: _alertLocal2.default.closeButton,
    'aria-label': 'Close'
  }, _react2.default.createElement(_icon2.default, {
    icon: 'close',
    size: 'small'
  })), Array.isArray(message) ? message.map(function (err) {
    return _react2.default.createElement('span', {
      key: err,
      className: _alertLocal2.default.alert__message
    }, err);
  }) : _react2.default.createElement('span', {
    className: _alertLocal2.default.alert__message
  }, message), secondaryMessage && _react2.default.createElement('span', {
    className: _alertLocal2.default.alert__secondaryMessage
  }, secondaryMessage));
};

Alert.defaultProps = {
  className: null,
  secondaryMessage: null,
  isVisible: true,
  onClose: null
};
Alert.propTypes = {
  /**
   *  Pass additional className to component
   */
  className: _propTypes2.default.string,

  /**
   *  Designate what kind of alert this is
   */
  kind: _propTypes2.default.oneOf(['notification', 'error', 'warning', 'success']).isRequired,

  /**
   *  Display an alert message
   */
  message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node, _propTypes2.default.array]).isRequired,

  /**
   *  Display an additional message to enhance user understanding
   */
  secondaryMessage: _propTypes2.default.any,

  /**
   *  Sets if the alert is visible/open
   */
  isVisible: _propTypes2.default.bool,

  /**
   *  Provide a function to handle a "close" action
   */
  onClose: _propTypes2.default.func
};
exports.default = Alert;